export default __webpack_public_path__ + "static/media/error.fb17f7b7.png";